.kdx-breadcrumbs ul {
    display: inline-block;
    list-style: none;
    padding: 0;
    margin: $gutter-def 0 0;

	.tm-bio-links a {
		color: #202B3C;
	}

	li {
		display: inline-block;
		list-style: none;
		color: #696969;
		@include text-size(14);
		@include line-height(20);
		font-weight: 600;
	
		.svg-icon {
			height: 15px;
			width: 15px;

			.tm-bio-links svg {
				fill: #202B3C;
			}
			
			svg {
				fill: $primary;
				transform: translateY(-3px);
				@include transitionDefault(fill);
			}
		}

		&:before {
			display: none;
		}
	
		&:after {
			content: '|';
			padding: 0 10px;
			color: #108479;
		}
	
		// link styles
		a {
			font-weight: 700;
			position: relative;
			text-decoration: none;
	
			&:after {
				content: '';
				position: absolute;
				display: block;
				bottom: 0px;
				left: 0;
				background-color: $primary;
				width: 100%;
				height: 1px;
				opacity: 1;
				@include transitionDefault(opacity);
			}
	
			&:hover, &:focus {
				color: #000;
	
				svg {
					fill: $gray-dark;
					@include transitionDefault(fill);
				}
	
				&:after {
					opacity: 0;
					@include transitionDefault(opacity);
				}
			}
		}

		&.active {
			&:after {
				display: none;
			}

			a {
				&:after {
					display: none;
				}
			}
		}
	}

    @include media-breakpoint-down(md) {
        display: none;
    }
}
